@if (pwaUpdate.isUpdateAvailable()) {
  <div
    class="pwa-banner-enter inline-flex min-h-11 items-center justify-center gap-2 rounded-lg border border-[var(--app-snackbar-outline)] bg-[var(--app-snackbar-surface)] px-2.5 py-1 text-[var(--app-snackbar-on-surface)] shadow-[var(--app-snackbar-shadow)] backdrop-blur-md md:min-h-12 md:gap-3 md:px-3.5 lg:gap-4 lg:px-5"
    aria-live="polite"
  >
    <span class="hidden pl-1 pr-2 text-xs font-medium text-[var(--app-snackbar-on-surface)] md:inline lg:pr-3">
      {{ 'pwaUpdateBannerHint' | transloco }}
    </span>

    <button
      matButton
      class="!min-w-0 !rounded-full !bg-[color-mix(in_srgb,var(--app-snackbar-on-surface)_12%,transparent)] !px-3 !text-[var(--app-snackbar-on-surface)] md:!px-4"
      [attr.aria-label]="'pwaUpdateAction' | transloco"
      [disabled]="pwaUpdate.isActivatingUpdate()"
      (click)="update()"
    >
      <mat-icon class="!h-[18px] !w-[18px] !text-[18px]">system_update_alt</mat-icon>
      {{ 'pwaUpdateAction' | transloco }}
    </button>

    <button
      matIconButton
      class="!h-9 !w-9 !text-[color:color-mix(in_srgb,var(--app-snackbar-on-surface)_82%,transparent)] md:!h-10 md:!w-10"
      [attr.aria-label]="'pwaUpdateDismiss' | transloco"
      [disabled]="pwaUpdate.isActivatingUpdate()"
      (click)="dismiss()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
}
